import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { environment } from '@src/environments/environment';
import { Log } from '../models/log';
import { SessionHelper } from './sessionHelper';
import { untilDestroyed } from '@ngneat/until-destroy';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  constructor(private router: Router, private http: HttpClient) {
    this.initialize();
  }

  private initialize() {
    //console.log('RouteService initialized');
    this.router.events.subscribe((event: Event) => {
      //console.log('event', event);
      if (event instanceof NavigationEnd) {
        if (SessionHelper.getUserSub() && SessionHelper.getChoosenOrg()) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          };
          const newLog: Log = {
            logurl: event.url,
            timeISO: new Date().toISOString(),
            loguser: SessionHelper.getUserSub(),
            organizationId: SessionHelper.getChoosenOrg(),
            message: 'Navigate end event',
            logtype: 'pageview',
          };
          this.http
            .post<any>(
              `${environment.apiUrl}/organization/${SessionHelper.getChoosenOrg()}/log`,
              newLog,
              httpOptions
            );
        }
      }
    });
  }
}